// extracted by mini-css-extract-plugin
export default {"myAccountContainer":"MyAccountParhato2_myAccountContainer__nnFc2","backButton":"MyAccountParhato2_backButton__YKdEn"};